import { FeatureFlagsAvailable } from '@components/featureFlags';
import {SCREEN_FEATURE_FLAGS} from '@config/navigationRestrictions';

export const isScreenAvailable = (screenName: string, featureFlags: Record<string, boolean> = {}): boolean => {
  const flag = SCREEN_FEATURE_FLAGS[screenName];
  return !flag || FeatureFlagsAvailable(flag, featureFlags);
};

export const filterScreensByFeatureFlags = <T extends { name: string }>(screens: T[], featureFlags: Record<string, boolean> = {}): T[] =>
  screens.filter((s) => isScreenAvailable(s.name, featureFlags));
